export const cmdDeviceDesktop = 'set-device-desktop',
    cmdDeviceTablet = 'set-device-tablet',
    cmdDeviceMobile = 'set-device-mobile',
    cmdClear = 'canvas-clear',
    cmdHelp = 'help',
    cmdSettings = 'settings',
    cmdTools = 'tools',
    cmdWebsite = 'website',
    cmdUpgrade = 'upgrade',
    cmdPreview = 'mdl-preview',
    leftPanel = [{
            label: 'Add',
            icon: '',
            color: 'light-blue', // panel theme color class(predefined)
            attributes: {
                class: 'fa fa-plus',
            }, // e.g class, title etc
            content: {
                type: 'blocks',
                html: '', // Use if not built in type, string or element
                help: 'help' // Link to help
            }
        },
        {
            label: 'Media',
            icon: '',
            color: 'yellow',
            attributes: {
                class: 'fa fa-image',
            },
            content: {
                type: 'assets',
                html: '',
                help: 'help'
            }
        }, {
            label: 'Twitch',
            icon: '',
            color: 'purple',
            attributes: {
                class: 'fa fa-twitch',
            },
            content: {
                type: 'twitch',
                html: '',
                help: 'help'
            }
        }, {
            label: 'Pages',
            icon: '',
            color: 'red',
            attributes: {
                class: 'fa fa-window-restore',
            },
            content: {
                type: 'themes',
                html: '',
                help: 'help'
            }
        }, {
            label: 'Settings',
            icon: '',
            color: 'grey',
            attributes: {
                class: 'fa fa-cog',
            },
            content: {
                type: 'settings',
                html: '',
                help: 'help'
            }
        }
    ],
    filters = [{
            filter: 'Text',
            secondary: ['Themed Text', 'Title', 'Paragraph']
        }, {
            filter: 'Blocks',
            secondary: ['All']
        }, {
            filter: 'Social Media',
            secondary: ['Social Bar', 'Facebook', 'Twitter', 'Pinterest', 'VK', 'LINE', 'YouTube', 'Spotify']
        }, {
            filter: 'Video & Music',
            secondary: ['Video Players', 'Video Gallery', 'Video Sections', 'Video Buttons', 'Audio Player', 'Soundcloud', 'Itunes', 'Spotify', 'Music Buttons']
        }, {
            filter: 'Merch',
            premium: 1,
            secondary: ['Hoodies', 'Tees', 'Caps']
        },
        /*{
                    filter: 'Image',
                    secondary: ['My Uploads', 'Social Images', 'Backgrounds', 'Image Library', 'Premium']
                }, {
                    filter: 'Nav Bars',
                    secondary: ['My Menus', 'Themed Menus', 'Default Menus']
                }, {
                    filter: 'Icons & Shapes',
                    secondary: ['Themed Lines', 'Basic Shapes', 'Arrows', 'Horizontal Lines', 'Vertical Lines', 'Featured', 'Animals & Nature', 'Icons', 'Logos & Badges', 'Characters', 'VideoBox', 'Video Mask', 'Transparent Video']
                }, {
                    filter: 'Contacts & Forms',
                    secondary: ['Contact', 'Payment', 'Multistep', 'Donation', 'Job Application', 'Feedback', 'Health', 'Contest', 'Price Quote', 'Subscribe', 'Maps', 'Fullwidth Maps']
                }, {
                    filter: 'My Designs',
                    secondary: ['All']
                }, {
                        filter: '*Dev Only*'
                }*/
    ];